//* This file contains the export files statement which will be export again in the pages




// -----------------------------  CONSTANTS -----------------------------
export { TRANSLATION } from '@/constants/common/internationalisation';
export { API, REDIRECT } from '@/constants/common/urls';
export { INTERVIEW_TYPES, INTERVIEW_TYPE_HEADERS } from '@/constants/common/interview-types';
export { JOB_STEPS } from '@/constants/common/jobs-steps';
export { QUESTION_TYPES } from '@/constants/common/question-types';
export { JOB_STAGES } from '@/constants/common/job-stages';
export { imageSize } from '@/constants/common/logo-sizes';
export { JOB_STATUSES } from '@/constants/common/job-statuses';
export { MY_INTERVIEW_JOBS } from '@/constants/common/my-interview-jobs';
export { WHITE_LABEL_CONSTANTS } from '@/constants/common/white-label-constants';
export {
        RESOURCE_NOT_FOUND_REPONSE_CODE, SERVER_ERROR_RESPONSE_CODE, SUCCESS_REPONSE_CODE,
        UNAUTHORIZED_REPONSE_CODE, UNPROCESSABLE_ENTITY_RESPONSE_CODE
} from '@/constants/common/response-code';
export { COMMON } from '@/constants/common/common';
// -----------------------------  CONSTANTS -----------------------------


// ----------------Fontawesome icons -----------------
export { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
export { faTimes, faExclamationCircle } from '@fortawesome/free-solid-svg-icons';
// ----------------Fontawesome icons -----------------


// ---------------------------- COMPONENTS -----------------------------

export { Formik, Form, Field, FieldArray, getIn, ErrorMessage, useFormik, useFormikContext } from 'formik';
export { default as dynamic } from 'next/dynamic';
export * as Yup from 'yup';
export { default as Link } from 'next/link';
export { default as React, Component, useEffect, useRef, useState, useCallback } from 'react';
export { default as HelmetMeta } from '@/pages/helmet_meta_data';
export { default as axios } from 'axios';
export { default as toastr } from 'toastr';
export { default as Image } from 'next/image';
export {getSession, SessionProvider, useSession, signIn} from 'next-auth/react';
export {useRouter} from 'next/router';
export {useTranslation} from 'react-i18next';
export {useNavbarStatus} from '@/hooks/use-navbar';
export { default as useSWR, mutate } from 'swr';
export { default as cookie} from 'cookie';
export { default as CSVReader} from 'react-csv-reader'
export { Datetime } from 'react-datetime'
export { useQuery, useQueryClient } from 'react-query';
export { AnimatePresence, motion } from 'framer-motion';
export { default as Select, components } from "react-select";
export { Checkbox } from "@material-ui/core";
export { default as moment } from 'moment';
export { default as useWindowDimension } from 'use-window-dimensions';
export { default as Tooltip } from 'react-simple-tooltip';
export { useUser } from '@/hooks/use-user';
// ---------------------------- COMPONENTS -----------------------------


// ---------------------------- COMMON ---------------------------------
export { CustomToastrAction } from '@/actions/components/custom-toastr';
export { handleOtherResponseCode } from '@/actions/common/response-handler';
export { NextServerCookies } from '@/actions/common/next-server-cookies';
export { createData } from '@/actions/common/create-data';
export { InputError } from '@/actions/common/input-error';
export { afterSigninPath } from '@/actions/common/after-signin-path';
export { SidebarAction } from '@/actions/components/sidebar';
export { goToNextPage } from '@/actions/common/go-to-next-page';
export { DataFromUrl } from '@/actions/common/data-from-url';
export { sendToCurrentSteps } from '@/actions/common/go-to-next-page';
export { clearSWRCache } from "@/actions/common/clear-cache";
export { addParamsToUrl, asyncAddParamsToUrl } from '@/actions/pages/admins/dashboard/clients/common';
export { ErrorPages } from '@/actions/common/render_error_loading';
export { BrowserDetect } from '@/actions/common/browser-detection';
export { CommonAction } from '@/actions/common/common';

// ---------------------------- COMMON ACTIONS ---------------------------------


// ---------------------------- ANIMATION -----------------------------
export { PAGE_ANIMATION_OPTIONS } from '@/constants/common/animation';
// ---------------------------- ANIMATION -----------------------------

export { CSV_OPTIONS } from '@/constants/common/csv-file';

// -----------------------------  CUSTOM COMPONENTS -----------------------------
export { default as Button } from '@/components/button';
export { AutocompleteError, CustomAutocompleteError } from '@/components/input';
export { default as Congrats } from '@/components/congrats';
export { FormikControl } from '@/components/formik-control';
export { Sidebar } from '@/components/sidebar';
export { MobileMenubar } from '@/components/mobile-menubar';
export { Loading } from '@/components/loading';

// -----------------------------  CUSTOM COMPONENTS -----------------------------

// ---------------- STYLESHEET -----------------
export { default as ButtonStyle } from '@/styles/components/button/_index.module.scss';
export { default as FormStyle } from '@/styles/layout/_form.module.scss';
// ---------------- STYLESHEET -----------------


// ---------------- SERVICE -----------------
export { SendRequest } from '@/services/common/send-request';
// ---------------- SERVICE -----------------


// ---------------------------- IMAGES ----------------------------
export { default as CandidateIcon } from "public/images/components/sidebar/candidate-icon.svg";
export { default as DashboardIcon } from "public/images/components/sidebar/dashboard-icon.svg";
export { default as DocumentIcon } from "public/images/components/sidebar/document-icon.svg";
export { default as JobIcon } from "public/images/components/sidebar/job-icon.svg";
export { default as ReportIcon } from "public/images/components/sidebar/report-icon.svg";
export { default as SettingsIcon } from "public/images/components/sidebar/setting-icon.svg";
export { default as ActivityIcon } from "public/images/components/sidebar/activity.svg";
export { default as BackToHome } from "public/images/components/sidebar/backToHome.svg";
export { default as CommunicationIcon } from "public/images/components/sidebar/communication.svg";
export { default as ClientIcon } from "public/images/components/sidebar/clients.svg";
export { default as UsersIcon } from "public/images/components/sidebar/users-icon.svg";
export { default as CompanyImage } from "public/images/components/sidebar/company-logo.png";
export { default as DotsImage } from 'public/images/components/sidebar/dots.png';
export { default as ClientDashboard } from "@/layouts/ClientDashboard";
export { default as ArrowLeftPng} from 'public/icons/arrowleft.png';
export { default as ArrowRightPng} from 'public/icons/arrowright.png';
export { default as CopyIcon} from 'public/icons/copy.svg';
export { default as Warning } from "public/icons/warning.svg";
export { default as Exclamation } from "public/icons/exclamation.svg"; 

// ---------------------------- IMAGES ----------------------------
//-----------------------------Amplitude Analytics----------------
export { init, identify, Identify, track  } from '@amplitude/analytics-browser';
